<template>
<div>
		<v-card class="mt-2 ml-2" :height="$vuetify.breakpoint.width > 1920 ? '500' : '500' ">
			<v-toolbar flat class="depttoolbar">
				<v-toolbar-title class="body-1">
		      		ATTRIBUTES
		    	</v-toolbar-title>
		    	<v-spacer></v-spacer>
		    	
		    	<v-tooltip left>
			    	<v-dialog slot="activator" width="500" v-model="deleteRoomConfirmDialog" v-if="isSuperUser">
						<template v-slot:activator="{ on }">
						<v-icon v-on="on" class="pr-3">delete</v-icon>
			        	</template>
			        	<v-card class="pl-2 pt-1 pr-2">
					        <v-card-title class="headline">Confirm Room Deletion</v-card-title>
					        <v-divider></v-divider>
					        <v-card-text class="pt-4 body-2">Delete Room {{room.number}} ?</v-card-text>
					        <v-card-actions>
					          	<v-spacer></v-spacer>
					          	<v-btn color="green darken-1" flat @click.native="deleteRoomConfirmDialog=false">No</v-btn>
					          	<v-btn color="green darken-1" flat 
					          		@click.native="delRoom(room.roomKey)">Yes
					      	 	 </v-btn>
					        </v-card-actions>
				      	</v-card>
			    	</v-dialog>
			    	Delete Room
		    	</v-tooltip>

				<v-toolbar-items>

				<v-tooltip v-if="changed" top>
					<v-btn slot="activator"  @click="cancel" icon><v-icon color="grey darken-3">cancel</v-icon></v-btn>
					<span>Cancel</span>
				</v-tooltip>
				
				<v-tooltip v-if="changed" top>
					<v-btn slot="activator"  @click="save" icon><v-icon color="grey darken-3">save</v-icon></v-btn>
					<span>Save</span>
				</v-tooltip>
				
				</v-toolbar-items>
			</v-toolbar>
			
	    		<v-layout column class="px-2 pt-2">
	    			<v-form v-model="valid" ref="form">
	    			<v-layout row class="mb-2">
		    			<v-flex class="mr-2">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="room.number"
				    			@input="changed=true"
				            	label="Number"
				            	:readonly="!isSuperUser">  
			            	</v-text-field>
			        	</v-flex>
			        	<v-flex  class="mr-2">
			        		<v-autocomplete
								:items="floorItems"
								@input="changed=true"
								item-text="label"
								item-value="value"
								v-model="room.floor"
								cache-items
								class="body-1 "
								flat
								light
								hide-no-data
								hide-details
								label="Floor"
								box
								:readonly="!isSuperUser"
								:rules="requiredRules"
							></v-autocomplete>
			        	</v-flex>
			        	<v-flex  class="mr-2">
			            	<v-autocomplete
								:items="restrictedChoices"
								@input="changed=true"
								item-text="label"
								item-value="value"
								v-model="room.restricted"
								cache-items
								class="body-1 "
								flat
								light
								hide-no-data
								hide-details
								label="Restricted"
								:readonly="!isSuperUser"
								box
							></v-autocomplete>
		        		</v-flex>
			        	<v-flex class="mr-2">
			    			<v-text-field v-if="!room.new" class="body-1" hide-details box
				    			v-model="room.area"
				    			@input="changed=true"
				    			readonly
				            	label="Area">  
			            	</v-text-field>
			        	</v-flex>
			        	<v-flex  class="mr-2">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="room.areaManual"
				    			@input="changed=true"	
				    			:readonly="!isSuperUser"			    			
				            	label="Man">  
			            	</v-text-field>
			        	</v-flex>
			        	<v-flex  class="mr-2">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="room.areaCAD"
				    			@input="changed=true"
				    			:readonly="!isSuperUser"
				            	label="CAD">  
			            	</v-text-field>
			        	</v-flex>
			        	<v-flex  class="mr-2">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="room.capacity"
				    			@input="changed=true"
				            	label="Capacity"
				            	:readonly="!isSuperUser && !isManagerOfRoom(room)">  
			            	</v-text-field>
		        		</v-flex>
		        		<!-- <v-flex  class="">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="room.tempCapacity"
				    			@input="changed=true"
				            	label="w/Distancing"
				            	:readonly="!isSuperUser">  
			            	</v-text-field>
		        		</v-flex> -->
			        </v-layout>

			        <v-layout row class="mb-2">
			        	<v-flex v-if="!room.new" xs10 class="mr-2">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="room.name"
				    			@input="changed=true"
				    			:readonly="!isSuperUser && !isManagerOfRoom(room)"
				            	label="Name">  
			            	</v-text-field>
		        		</v-flex>
		        		<v-flex xs3 class="mr-2" style="height: 55px;">
							<v-menu
					          ref="menu2"
					          v-model="menu2"
					          :close-on-content-click="false"
					          :nudge-right="40"
					          lazy
					          transition="scale-transition"
					          offset-y
					          full-width
					          max-width="290px"
					          min-width="290px"
					        >
					          <template v-slot:activator="{ on }">
					            <v-text-field
					              v-model="room.dateInventory"
					              label="Inventory"
					              class="body-1"	
					              flat
					              box
					              readonly
					              v-on="on"
					            ></v-text-field>
					          </template>
					          <v-date-picker v-model="room.dateInventory" :readonly="!isSuperUser"
					          	@input="changed = true; menu2 = false"></v-date-picker>
					        </v-menu>
						</v-flex>

		        		<v-flex  class="mr-2">
			    			<v-text-field class="body-1" hide-details box
			    				v-if="!room.new"
				    			v-model="room.dwgName"
				    			@input="changed=true"
				            	label="Drawing"
				            	:readonly="!isSuperUser"
				            	:rules="noPeriod">  
			            	</v-text-field>
		        		</v-flex>
		        		<v-flex class="">
			    			<v-text-field class="body-1" hide-details box
			    				v-if="!room.new"
				    			v-model="room.ehandle"
				    			@input="changed=true"
				    			:readonly="!isSuperUser"
				            	label="eHandle">  
			            	</v-text-field>
		        		</v-flex>	        		
		        	</v-layout>

		        	<v-layout row class="mb-2">
		        		<v-flex class="mr-2">
			    			<v-select class="body-1" hide-details box
			    				:items="['Fair', 'Good', 'Poor']"
				    			v-model="room.condition"
				    			@input="changed=true"
				            	label="Condition"
				            	:readonly="!isSuperUser">  
			            	</v-select>
		        		</v-flex>
		        		<v-flex class="mr-2">
			    			<v-select class="body-1" hide-details box
			    				:items="['High', 'Low', 'Vacant']"
				    			v-model="room.utilization"
				    			@input="changed=true"
				            	label="Utilization"
				            	:readonly="!isSuperUser">  
			            	</v-select>
		        		</v-flex>
		        		<v-flex class="">
			    			<v-select class="body-1" hide-details box
			    				:items="['Aligned', 'Not aligned', 'Misaligned']"
				    			v-model="room.suitability"
				    			@input="changed=true"
				            	label="Suitability"
				            	:readonly="!isSuperUser">  
			            	</v-select>
		        		</v-flex>
		        	</v-layout>
		        		

		        	<v-layout row class="mb-2">

		        		<v-flex v-if="!room.new" xs6>
					        <v-text-field hide-details box								
								v-model="categoryLabel"
								@input="changed=true"
								cache-items
								readonly
								class="mr-2 body-1"									
								label="Category"									
							></v-text-field>
						</v-flex>
			        	
			        	<v-flex xs6>
				        	<v-autocomplete
								:items="types"
								@input="changed=true"
								item-text="nameAndID"
								item-value="typeID"
								v-model="room.type"
								cache-items
								class="body-1"
								flat
								light
								hide-no-data
								hide-details
								label="Type"
								box
								:readonly="!isSuperUser && !isManagerOfRoom(room)"
							></v-autocomplete>
						</v-flex>
		        	</v-layout>
		        	<v-layout row class="mb-2">

				        <v-flex xs6>
				        	<v-autocomplete
								:items="uses"
								@input="changed=true"
								item-text="nameAndID"
								item-value="useID"
								v-model="room.use"
								cache-items
								class="mr-2 body-1"									
								flat
								light
								hide-no-data
								hide-details
								label="Use"
								box
								:readonly="!isSuperUser && !isManagerOfRoom(room)"
							></v-autocomplete>
						</v-flex>
			        	
			        	<v-flex v-if="!room.new" xs6>
			        		<v-autocomplete
								:items="classifications"
								@input="changed=true"
								item-text="classificationName"
								item-value="classificationName"
								v-model="room.classification"
								cache-items
								class="body-1"
								flat
								light
								hide-no-data
								hide-details
								label="Classification"
								box
								:readonly="!isSuperUser && !isManagerOfRoom(room)"
							></v-autocomplete>
						</v-flex>
		        	</v-layout>	   			
				
				<v-layout v-if="isSuperUser" >
					<v-flex xs12 style="overflow-y: auto; height: 112px;">
						<v-textarea 
				          box 
				          height="111"
				          class="body-1"
				          label="Comments"
				          v-model="room.comment"
				          @input="changed=true"
				        ></v-textarea>
				        <v-textarea
				          box 
				          height="111"
				          class="body-1"
				          label="Dept Manager Comments"
				          v-model="room.commentMgr"
				          @input="changed=true"
				        ></v-textarea>
			    	</v-flex>
				</v-layout>

				<v-layout v-if="!isSuperUser && isManagerOfRoom(room)" >
					<v-flex xs12 >
				        <v-textarea
				          box 
				          height="111"
				          class="body-1"
				          label="Dept Manager Comments"
				          v-model="room.commentMgr"
				          @input="changed=true"
				        ></v-textarea>
			    	</v-flex>
				</v-layout>


				</v-form>
		    	</v-layout>	
			
			
		</v-card>
</div>
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
name: 'RoomBasic',
data () {
	return {	menu2: false,
				deptSelect: null,
				collegeSelect: null,
				changed: false,
				valid: false,
				restrictedChoices: [	{ label: 'Yes', value: 'Y' }, 
										{ label: 'No', value: null }
									],
				deleteRoomConfirmDialog: false,
				requiredRules:  [	v => !!v || "Field is required", ],
				noPeriod: 		[	v => !v || !v.includes('.') || "ex: 21-1", ],
	}
},

computed: {
	...mapState({   	room: state => state.dv.room,
						depts: state => state.lists.depts,
						colleges: state => state.lists.colleges,
						types: state => state.lists.types,
						uses: state => state.lists.uses,
						classifications: state => state.lists.classifications,
						building: state => state.dv.building,
						isSuperUser: state => state.user.isSuperUser,
				}),
	
	...mapGetters(['allowManagerUI', 'isManagerOfRoom', 'getBuilding']),
	
	categoryLabel: function () {
		return `${this.room.categoryName} (${this.room.category})`
	},

	floorItems: function () {		
		return this.getBuilding(this.room.bldgAlpha).floors 
	},


},

methods : {
	...mapMutations([ 	'setBuildings',						
						'setCurrentDept',
						'setLoadingRoomDetail',
						'setdvBuildingRooms',
						'setSnackText',
						'setdvFloor'
					]),

	...mapActions([		'saveRoom',
						'fetchFullRoom',
						'deleteRooms',
						'fetchBuildingRooms',
						'fetchFloor',
						'setRoom',
				  ]),

	save : function () {
		
		if (!this.valid) {
				this.setSnackText("Form has validation errors");
				return;
			}
		this.setLoadingRoomDetail(true)

		// Set dateInventory to now
		this.room.dateInventory = new Date().toISOString().slice(0,10);

		this.saveRoom(this.room).then((data) => {	
			console.log(data)		 
			if (data == "Saved") {
				this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => { 
					this.setRoom(data) 
					this.setLoadingRoomDetail(false)
					
					this.fetchFloor({
						bldgAlpha: this.room.bldgAlpha,
						floor: this.room.floor
					}).then(data => {
						this.setdvFloor(data);
					});
			
					this.changed = false
				})
			} else {
				this.setSnackText(data)
				this.setLoadingRoomDetail(false)
			}
			
			this.fetchBuildingRooms(this.room.bldgAlpha).then((data) => { 
				this.setdvBuildingRooms(data)
			})
		})
	},

	delRoom: function (roomKey) {
		this.deleteRooms( { 'roomArray': [roomKey] } )
		this.deleteRoomConfirmDialog=false
		this.fetchBuildingRooms(this.room.bldgAlpha).then((data) => { 
			this.setdvBuildingRooms(data)
		})
		this.setRoom(null)
	},

	cancel : function () {
		this.setLoadingRoomDetail(true)
		this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => { 
			this.setRoom(data) 
			this.setLoadingRoomDetail(false)
			this.$nextTick(() => { this.changed = false })
		})
	}
},
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomDetailBasic.vue